module.exports = __webpack_public_path__ + "static/media/display.3b299fb0.svg";